import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DocumentCard from "components/card/DocumentCard";
import Card from "components/card";
import { FileCheck, FilePlusCorner } from "lucide-react";
import {
    getEmployeeDocumentList,
} from "../../../../redux/document/documentState";
import DocumentForm from "./components/DocumentForm";
import PopupButton from "components/button/PopupButton";

const EmployeeDocuments = ({employeeId}) => {
	
	const dispatch = useDispatch();
	const documentList = useSelector((state) => state.document.employeeDocumentList?.items);
	
	useEffect(() => {
		dispatch(getEmployeeDocumentList({recordId: employeeId }));
	}, [dispatch, employeeId]);
	
	return (
	    <div>
			<div className="flex mb-4">
				<PopupButton
					id="upload_employee_document"
					title="Upload Document"
					label="Upload Document"
					btnClass="btn-small"
					icon={FilePlusCorner}
				>
					<DocumentForm
						recordId={0}
						mode="edit"
						employeeId={employeeId}
					/>
				</PopupButton>
			</div>
			<div className="space-y-3">
				{documentList?.map((doc) => (
					<DocumentCard
						key={doc.doc_id}
						title={doc.doc_title}
						description={doc.doc_description}
						status={doc.doc_status_name}
						date={doc.doc_date}
						size={doc.doc_size}
						icon={<FileCheck className="w-5 h-5 text-blue-600" />}
						documentData={doc}
						onDownload={() => console.log(`Download ${doc.title}`)}
					/>
				))}
			</div>
	    </div>
    );
};

export default EmployeeDocuments;